module.exports = __webpack_public_path__ + "static/media/googlecloud.53ed7608.jpg";